'use client';

import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import type { ReactNode } from 'react';
import { queryClient } from '@/shared/lib/query-client';
import {
  queryPersister,
  shouldPersistQuery,
} from '@/shared/lib/query-persister';

interface QueryProviderProps {
  children: ReactNode;
}

const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

// Buster ties persisted cache to the current build. A deploy that renames
// query keys or changes response shapes bumps NEXT_PUBLIC_APP_VERSION, which
// discards the old IDB snapshot instead of hydrating stale data into code
// that no longer understands it. NOTE it is a CONSTANT wherever no version is
// set (local builds), so it cannot be relied on to expire anything — data that
// must not survive a rebuild has to stay out of the persisted set entirely
// (see `shouldPersistQuery`).
const buster = process.env.NEXT_PUBLIC_APP_VERSION || 'dev';

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryPersister,
        maxAge: SEVEN_DAYS_MS,
        buster,
        dehydrateOptions: {
          shouldDehydrateQuery: shouldPersistQuery,
        },
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
